import { render, staticRenderFns } from "./chapterList.vue?vue&type=template&id=28d04b36"
import script from "./chapterList.vue?vue&type=script&lang=js"
export * from "./chapterList.vue?vue&type=script&lang=js"
import style0 from "./chapterList.vue?vue&type=style&index=0&id=28d04b36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports